// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import { Switch as SwitchComponent } from '@material-ui/core';

const Switch = ({ checked, onChange, disabled, classes }) => {
  return <SwitchComponent checked={checked} disabled={disabled} onChange={onChange} className={classes.switch} />;
};

Switch.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

Switch.defaultProps = {
  classes: {},
  checked: false,
  onChange: () => {},
  disabled: false,
};

export default Switch;
